import cx from 'classnames';
import type React from 'react';
import CTContent from './CTContent';
import CTIcon from './CTIcon';
import CTTooltip from './CTTooltip/CTTooltip';
import CTTooltipContent from './CTTooltip/CTTooltipContent';

type ToolTip = {
  strong: string;
  text: string;
};

type Content = {
  heading1?: string;
  heading2?: string;
  subHeading: string;
};

export type ConditionalTileData = {
  tooltip?: ToolTip;
  content: Content;
  button?: string;
  hasMargin?: boolean;
};

type OwnProps = {
  hideIcon?: boolean;
  isMobile?: boolean;
  data: ConditionalTileData;
  light?: boolean;
  top?: boolean;
  bottom?: boolean;
  small?: boolean;
  smallest?: boolean;
  showTooltip?: boolean;
  svgIcon?: React.ReactNode;
  hasButton?: boolean;
  hasTextButton?: boolean;
  primaryButton?: boolean;
  secondaryButton?: boolean;
  backgroundButton?: boolean;
  hasToolTip?: boolean;
  hasMobileSubText?: boolean;
  event?: any;
};

export default function ConditionalTile({
  hideIcon = false,
  isMobile,
  data: { tooltip, content, button, hasMargin = false },
  light = false,
  top = false,
  bottom = false,
  small = false,
  smallest = false,
  showTooltip = false,
  svgIcon,
  hasButton = false,
  hasTextButton = false,
  primaryButton = false,
  secondaryButton = false,
  backgroundButton = false,
  hasToolTip = true,
  hasMobileSubText = false,
  event
}: OwnProps) {
  return (
    <div
      className={cx('ct-container', {
        top,
        bottom,
        small,
        smallest
      })}
    >
      {hasToolTip && (
        <CTTooltip
          tooltip={showTooltip}
          light={light}
          isMobile={isMobile}
          eventTracker={event}
          content={
            <CTTooltipContent options={tooltip ?? {}} isMobile={isMobile} />
          }
        />
      )}
      <div
        className={cx('ct-content-wrapper', {
          mobile: isMobile,
          top,
          small,
          smallest,
          bottom
        })}
      >
        <CTIcon
          hideIcon={hideIcon}
          isMobile={isMobile}
          svgIcon={svgIcon}
          hasMargin={hasMargin}
        />
        <CTContent
          options={content}
          buttonText={button}
          button={hasButton}
          textButton={hasTextButton}
          bottom={bottom}
          top={top}
          light={light}
          backgroundButton={backgroundButton}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
          smallest={smallest}
          isMobile={isMobile}
          hasMobileSubText={hasMobileSubText}
        />
      </div>
    </div>
  );
}
